import React from 'react';
import classNames from 'classnames';
import Wrapper from './Wrapper';

const ValidatedTextAreaField = ({ inputCol, disabled, hint, input, label, placeholder, className, meta: { touched, error } }) => {
    if(placeholder === null || placeholder === undefined) {
        placeholder = placeholder || label;
    }

    error = (touched) ? error : undefined;

    return <Wrapper
        inputCol={inputCol}
        label={label}
        error={error}
    >
        <textarea {...input} className={className} disabled={disabled} placeholder={placeholder}/>
        {hint}
    </Wrapper>
};

export default ValidatedTextAreaField;


// WEBPACK FOOTER //
// ./web/src/components/common/form/ValidatedTextAreaField.jsx